package fr.frux.feature.treeadd.wizard

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import fr.frux.core.designsystem.icons.FruxSpeciesGlyphs
import fr.frux.core.designsystem.icons.glyphFor
import fr.frux.core.designsystem.icons.legendColor
import fr.frux.core.designsystem.icons.speciesFamilyKey
import fr.frux.core.designsystem.theme.fruxColors
import fr.frux.shared.domain.model.Species

/** Glyphe de la carte pour une espèce, repli sur la fleur quand aucun n'est connu. */
@Composable
internal fun speciesGlyph(
    scientificName: String,
    harvestPart: String?,
): ImageVector = glyphFor(scientificName, harvestPart) ?: FruxSpeciesGlyphs.Fleur

/** Teinte de famille de la carte, partagée avec les marqueurs. */
@Composable
internal fun speciesTint(scientificName: String): Color =
    speciesFamilyKey(scientificName).legendColor(MaterialTheme.fruxColors)

@Composable
internal fun Species.glyph(): ImageVector = speciesGlyph(scientificName, harvests.firstOrNull()?.part?.name)
